import { api } from './axios';
import type { AuditFilter, AuditLogEntry, AuditPage } from '../types/audit';

export const auditApi = {
  list: (filter: AuditFilter = {}) => {
    const params: Record<string, unknown> = {};
    if (filter.unitId != null) params.unitId = filter.unitId;
    if (filter.competitionId != null) params.competitionId = filter.competitionId;
    if (filter.entityType) params.entityType = filter.entityType;
    if (filter.entityId != null) params.entityId = filter.entityId;
    if (filter.userId != null) params.userId = filter.userId;
    if (filter.action) params.action = filter.action;
    if (filter.from) params.from = filter.from;
    if (filter.to) params.to = filter.to;
    params.page = filter.page ?? 0;
    params.size = filter.size ?? 50;
    return api.get<AuditPage>('/admin/audit', { params }).then((r) => r.data);
  },

  resultHistory: (resultId: number) =>
    api.get<AuditLogEntry[]>(`/admin/audit/results/${resultId}/history`).then((r) => r.data),
};
